import React from 'react';
import styled, { keyframes } from 'styled-components';
import { type ThemeConfig, useTheme } from '../../theme';

interface AssistantThoughtFeedbackProps {
  content: string;
  speed: number;
  disabled: boolean;
  className: string;
}

const AssistantThoughtFeedback: React.FC<AssistantThoughtFeedbackProps> = ({
  content,
  speed,
  disabled = false,
  className
}) => {
  const theme = useTheme();
  const animationDuration = `${speed}s`;
  return (
    <Wrapper theme={theme}>
      <p
        className={`shiny-text ${disabled ? 'disabled' : ''} ${className}`}
        style={{ animationDuration }}
      >
        {content}
      </p>
    </Wrapper>
  );
};

const shine = keyframes`
  0% {
    background-position: 100%;
  }
  100% {
    background-position: -100%;
  }
`;

const Wrapper = styled.div<{ theme: ThemeConfig }>`
  .shiny-text {
    background: linear-gradient(
      120deg,
      ${({ theme }) => (theme.mode === 'dark' ? '#b5b5b5a4' : '#6b7280')} 40%,
      ${({ theme }) =>
          theme.mode === 'dark' ? 'rgba(255, 255, 255, 0.8)' : 'rgba(59, 130, 246, 0.8)'}
        50%,
      ${({ theme }) => (theme.mode === 'dark' ? '#b5b5b5a4' : '#6b7280')} 60%
    );
    background-size: 200% 100%;
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    color: transparent;
    display: inline-block;
    animation: ${shine} 5s linear infinite;
  }

  .shiny-text.disabled {
    animation: none;
    background: ${({ theme }) => (theme.mode === 'dark' ? '#b5b5b5a4' : '#6b7280')};
    -webkit-text-fill-color: ${({ theme }) => (theme.mode === 'dark' ? '#b5b5b5a4' : '#6b7280')};
    color: ${({ theme }) => (theme.mode === 'dark' ? '#b5b5b5a4' : '#6b7280')};
  }
`;

export default AssistantThoughtFeedback;
